import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';

enum MonolithAssessmentSlug {
  BASELINE = 'baseline-questionnaire',
  FUNCTIONAL = 'functional-questionnaire',
  GAD_7 = 'gad7-assessment',
  PCL_5 = 'pcl5-questionnaire',
  PHQ_9 = 'phq9-assessment',
  THERAPEUTIC_ALLIANCE = 'therapeutic-alliance',
}

enum MonolithAssessmentSlugRoot {
  BASELINE = 'baseline',
  FUNCTIONAL = 'functional',
  GAD_7 = 'gad7',
  PCL_5 = 'pcl5',
  PHQ_9 = 'phq9',
  THERAPEUTIC_ALLIANCE = 'therapeutic'
}

const cqTypeToSlugMap = {
  [ClinicalAssessmentTypes.FUNCTIONAL]: MonolithAssessmentSlug.FUNCTIONAL,
  [ClinicalAssessmentTypes.GAD_7]: MonolithAssessmentSlug.GAD_7,
  [ClinicalAssessmentTypes.PCL_5]: MonolithAssessmentSlug.PCL_5,
  [ClinicalAssessmentTypes.PHQ_9]: MonolithAssessmentSlug.PHQ_9,
  [ClinicalAssessmentTypes.THERAPEUTIC_ALLIANCE]: MonolithAssessmentSlug.THERAPEUTIC_ALLIANCE,

  // For all other CQ types, we don't need a slug because they don't use FormWizard
  [ClinicalAssessmentTypes.AUDIT_C]: '',
  [ClinicalAssessmentTypes.CSSRS_ADULTS]: '',
  [ClinicalAssessmentTypes.CSSRS_KIDS]: '',
  [ClinicalAssessmentTypes.PROMIS_ANGER]: '',
  [ClinicalAssessmentTypes.PROMIS_ANXIETY]: '',
  [ClinicalAssessmentTypes.PROMIS_DEPRESSION]: '',
  [ClinicalAssessmentTypes.S2BI]: '',
};

const slugToCqTypeMap = {
  [MonolithAssessmentSlugRoot.FUNCTIONAL]: ClinicalAssessmentTypes.FUNCTIONAL,
  [MonolithAssessmentSlugRoot.GAD_7]: ClinicalAssessmentTypes.GAD_7,
  [MonolithAssessmentSlugRoot.PCL_5]: ClinicalAssessmentTypes.PCL_5,
  [MonolithAssessmentSlugRoot.PHQ_9]: ClinicalAssessmentTypes.PHQ_9,
  [MonolithAssessmentSlugRoot.THERAPEUTIC_ALLIANCE]: ClinicalAssessmentTypes.THERAPEUTIC_ALLIANCE,
  // Baseline are of type FUNCTIONAL/GAD7/PHQ9, any of these values are ok
  [MonolithAssessmentSlugRoot.BASELINE]: ClinicalAssessmentTypes.FUNCTIONAL,
};

export function getSlugForAssessmentType(cqType: ClinicalAssessmentTypes, isBaselineQuestionnaire: boolean): string {
  return isBaselineQuestionnaire ? MonolithAssessmentSlug.BASELINE : cqTypeToSlugMap[cqType];
}

export function getAssessmentTypeFromSlug(slug: string): ClinicalAssessmentTypes {
  // Get first part of slug, remove any -questionnaire, -paginated, or _version suffixes
  const baseSlug = slug.split('-')[0];
  return slugToCqTypeMap[baseSlug as MonolithAssessmentSlugRoot];
}

export function getUserFriendlyTitle(cqType: ClinicalAssessmentTypes): string {
  switch (cqType) {
    case ClinicalAssessmentTypes.AUDIT_C:
      return 'Alcohol use';
    case ClinicalAssessmentTypes.CSSRS_ADULTS:
      return 'Suicidality (C-SSRS)';
    case ClinicalAssessmentTypes.CSSRS_KIDS:
      return 'Suicidality (C-SSRS Pediatric)';
    case ClinicalAssessmentTypes.FUNCTIONAL:
      return 'Day-to-day life';
    case ClinicalAssessmentTypes.GAD_7:
      return 'Anxiety symptoms';
    case ClinicalAssessmentTypes.PCL_5:
      return 'Trauma symptoms';
    case ClinicalAssessmentTypes.PHQ_9:
      return 'Depression symptoms';
    case ClinicalAssessmentTypes.PROMIS_ANGER:
      return 'Anger (PROMIS Pediatric Anger)';
    case ClinicalAssessmentTypes.PROMIS_ANXIETY:
      return 'Anxiety (PROMIS Pediatric Anxiety)';
    case ClinicalAssessmentTypes.PROMIS_DEPRESSION:
      return 'Depression (PROMIS Pediatric Depression)';
    case ClinicalAssessmentTypes.S2BI:
      return 'Substance use';
    default:
      return '';
  }
}
